/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:12:06
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-09 16:04:35
 */
import req from "@/utils/request";

//  get 请求示列
export const selectPage = (params) => req.post("/manager-service/m/user/selectPage", params);
